import React from 'react';
import { motion } from 'framer-motion';

const Technologies: React.FC = () => {
  const techGroups = [
    {
      title: 'Frontend',
      label: 'Interfaces',
      tech: ['React.js', 'Next.js', 'TypeScript', 'JavaScript', 'HTML5', 'CSS3', 'Tailwind CSS', 'Bootstrap', 'Framer Motion', 'Three.js']
    },
    {
      title: 'Backend',
      label: 'Systems',
      tech: ['Node.js', 'Express.js', 'PHP', 'Laravel', 'Python', 'REST APIs', 'GraphQL', 'Serverless']
    },
    {
      title: 'Data',
      label: 'Storage',
      tech: ['PostgreSQL', 'MySQL', 'MongoDB', 'Redis', 'Firebase', 'Supabase', 'Prisma']
    },
    {
      title: 'Cloud',
      label: 'Delivery',
      tech: ['AWS', 'Google Cloud', 'Vercel', 'Netlify', 'Docker', 'CI/CD', 'GitHub Actions']
    }
  ];

  return (
    <motion.section id="technologies" className="technologies" initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
      <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
        Cutting-Edge Technology Stack
      </motion.h2>
      <p className="section-subtitle">A focused toolkit for fast, responsive, scalable websites and applications.</p>
      <div className="tech-grid tech-category-grid">
        {techGroups.map((group) => (
          <div className="tech-category" key={group.title}>
            <div className="tech-category-header">
              <span className="tech-category-label">{group.label}</span>
              <span className="tech-category-count">{group.tech.length}</span>
            </div>
            <h3>{group.title}</h3>
            <ul>
              {group.tech.map((tech) => (
                <li key={tech}>{tech}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </motion.section>
  );
};

export default Technologies;
